export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[800px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading mb-3">
            联系我们
          </h2>
          <p className="text-foreground-600 max-w-lg mx-auto">
            有任何问题或建议，欢迎与我们联系
          </p>
        </div>

        <div className="bg-background-100 border border-background-200 rounded-2xl p-8 md:p-10">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mx-auto mb-3">
                <i className="ri-mail-line text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">
                商务合作
              </h3>
              <p className="text-xs text-foreground-500">business@7777cinema.com</p>
            </div>

            <div className="text-center">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mx-auto mb-3">
                <i className="ri-customer-service-2-line text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">
                用户反馈
              </h3>
              <p className="text-xs text-foreground-500">feedback@7777cinema.com</p>
            </div>

            <div className="text-center">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-600 mx-auto mb-3">
                <i className="ri-article-line text-xl"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">
                内容投稿
              </h3>
              <p className="text-xs text-foreground-500">content@7777cinema.com</p>
            </div>
          </div>

          <div className="mt-8 pt-8 border-t border-background-200">
            <p className="text-sm text-foreground-500 text-center leading-relaxed">
              我们重视每一位用户的反馈，无论是功能建议、内容推荐还是问题报告，
              都欢迎通过以上方式与我们取得联系。我们的团队将在24小时内回复您的邮件。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}